module.exports = __webpack_public_path__ + "static/media/SOSIcon.f9876f95.svg";